const AUTH_KEY = 'isAuthenticated';
const ACCOUNT_KEY = 'id_account_caisse';
const CAISSE_KEY = 'id_caisse';
const LAST_ROUTE_KEY = 'kds_last_route';

export function getStoredSession() {
  return {
    isAuthenticated: localStorage.getItem(AUTH_KEY) === 'true',
    id_account_caisse: localStorage.getItem(ACCOUNT_KEY),
    id_caisse: localStorage.getItem(CAISSE_KEY),
  };
}

export function isSessionValid(session = getStoredSession()) {
  const { isAuthenticated, id_account_caisse, id_caisse } = session;
  return (
    isAuthenticated &&
    id_account_caisse != null &&
    id_account_caisse !== '' &&
    id_caisse != null &&
    id_caisse !== ''
  );
}

export function saveSession({ id_account_caisse, id_caisse }) {
  localStorage.setItem(AUTH_KEY, 'true');
  localStorage.setItem(ACCOUNT_KEY, String(id_account_caisse));
  localStorage.setItem(CAISSE_KEY, String(id_caisse));
}

export function clearSession() {
  localStorage.removeItem(AUTH_KEY);
  localStorage.removeItem(ACCOUNT_KEY);
  localStorage.removeItem(CAISSE_KEY);
  localStorage.removeItem('hasInteracted');
  // Never reuse another account's kitchen screen after logout/login.
  localStorage.removeItem(LAST_ROUTE_KEY);
}

export function getLastRoute() {
  const route = localStorage.getItem(LAST_ROUTE_KEY);
  if (route && route !== '/') return route;
  return '/dashboard';
}

export function saveLastRoute(pathname, search = '') {
  const path = `${pathname}${search}`;
  if (pathname !== '/') {
    localStorage.setItem(LAST_ROUTE_KEY, path);
  }
}
